import { render } from "./DataPrivacyContent.vue?vue&type=template&id=7020eb3a"
import script from "./DataPrivacyContent.vue?vue&type=script&lang=js"
export * from "./DataPrivacyContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__